import { h, Component } from 'preact';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class DropdownOrder extends Component {
  render() {
    const { sortOptions } = this.props;

    return (
      <div
        ref={node => (this.ref = node)}
        className="dropdown-order search-filter-simple__drop search-filter-simple__item"
      >
        <div className="card-collapse-deep search-filter-simple__drop-item">
          <div className="card-collapse-deep__header">
            <div>Ordenar</div>

            <button type="button" onClick={this.props.onClose}>
              <i className="icon icon-close text-dark" />
            </button>
          </div>

          <ul className="list list--border-bottom">
            {sortOptions.map(sortItem => (
              <li
                className={classNames(
                  'card-collapse-deep__title card-collapse-deep__title--link',
                  {
                    'card-collapse-deep__title--link-active':
                      sortItem.paramValue === this.props.value,
                  },
                )}
                onClick={() => {
                  this.props.onSetSortParams(sortItem);
                }}
              >
                <strong>{sortItem.title}</strong>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

DropdownOrder.defaultProps = {
  sortOptions: [
    { title: 'Mais Recente', paramValue: '-created_at' },
    { title: 'Mais Antigo', paramValue: 'created_at' },
    { title: 'Mais Relevante', paramValue: 'ordination' },
    { title: 'Por Nome A/Z', paramValue: 'name' },
    { title: 'Por Nome Z/A', paramValue: '-name' },
  ],
  onSetSortParams() {},
  onClose() {},
};

DropdownOrder.propTypes = {
  value: PropTypes.string.isRequired,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      paramValue: PropTypes.string,
    }),
  ),
  onSetSortParams: PropTypes.func,
  onClose: PropTypes.func,
};

export default DropdownOrder;
